import React from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Reels_Hero from "./Reels_Hero/Reels_Hero";
import Reels_ServiceSection from "./Reels_ServiceSection/Reels_ServiceSection";
import Reels_Features from "./Reels_Features/Reels_Features";
import Reels_FeaturesSpecial from "./Reels_Features/Reels_Features";
import Reels_Testimonial from "./Reels_Testimonial";
import Reels_Counter_Exp from "./Reels_Counter_Exp/Reels_Counter_Exp";
import Reels_Faq from "./Reels_FAQ/Reels_FAQ";
import Footer from "../../Components/Footer/Footer";

const SchoolMS = () => {
  return (
    <div>
      <Navbar></Navbar>
      <Reels_Hero></Reels_Hero>
      <Reels_ServiceSection></Reels_ServiceSection>
      {/* <Reels_Features></Reels_Features> */}
      {/* <Reels_FeaturesSpecial></Reels_FeaturesSpecial> */}
      {/* <Reels_Testimonial></Reels_Testimonial> */}
      <Reels_Counter_Exp></Reels_Counter_Exp>
      <Reels_Faq></Reels_Faq>
      <Footer></Footer>
    </div>
  );
};

export default SchoolMS;
